/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One row of the definitions list.
 * 
 * Deliberately free of the condition trees the aggregate read carries — the list exists to pick
 * a definition, and the two counts are what say whether one is configured at all. Both are
 * annotated by the view's queryset rather than counted per row.
 * @export
 * @interface WorkflowDefList
 */
export interface WorkflowDefList {
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefList
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefList
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefList
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkflowDefList
     */
    owner?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefList
     */
    readonly ownerName: string | null;
    /**
     * Is this workflow active? Inactive definitions are not used in new workflows.
     * @type {boolean}
     * @memberof WorkflowDefList
     */
    isActive?: boolean;
    /**
     * When enabled, events from the same batch that share a grouping field (e.g. site or equipment) will be linked. Configure the linking rule below.
     * @type {boolean}
     * @memberof WorkflowDefList
     */
    autoEventLinking?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkflowDefList
     */
    readonly transitionCount: number;
    /**
     * 
     * @type {number}
     * @memberof WorkflowDefList
     */
    readonly actionCount: number;
    /**
     * 
     * @type {Date}
     * @memberof WorkflowDefList
     */
    readonly updatedAt: Date | null;
}

/**
 * Check if a given object implements the WorkflowDefList interface.
 */
export function instanceOfWorkflowDefList(value: object): value is WorkflowDefList {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if ((!('ownerName' in (value as Record<string, any>)) && !('owner_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['ownerName'] === undefined && (value as Record<string, any>)['owner_name'] === undefined)) return false;
    if ((!('transitionCount' in (value as Record<string, any>)) && !('transition_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['transitionCount'] === undefined && (value as Record<string, any>)['transition_count'] === undefined)) return false;
    if ((!('actionCount' in (value as Record<string, any>)) && !('action_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['actionCount'] === undefined && (value as Record<string, any>)['action_count'] === undefined)) return false;
    if ((!('updatedAt' in (value as Record<string, any>)) && !('updated_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['updatedAt'] === undefined && (value as Record<string, any>)['updated_at'] === undefined)) return false;
    return true;
}

export function WorkflowDefListFromJSON(json: any): WorkflowDefList {
    return WorkflowDefListFromJSONTyped(json, false);
}

export function WorkflowDefListFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDefList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'ownerName': json['owner_name'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'autoEventLinking': json['auto_event_linking'] == null ? undefined : json['auto_event_linking'],
        'transitionCount': json['transition_count'],
        'actionCount': json['action_count'],
        'updatedAt': (json['updated_at'] == null ? null : new Date(json['updated_at'])),
    };
}

export function WorkflowDefListToJSON(json: any): WorkflowDefList {
    return WorkflowDefListToJSONTyped(json, false);
}

export function WorkflowDefListToJSONTyped(value?: Omit<WorkflowDefList, 'id'|'ownerName'|'transitionCount'|'actionCount'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'owner': value['owner'],
        'is_active': value['isActive'],
        'auto_event_linking': value['autoEventLinking'],
    };
}

